import { PropsWithChildren } from 'react';
import { MegaMenuProvider } from '../04-organisms/MegaMenuProvider';
import { SidepanelProvider } from '../04-organisms/SidepanelProvider';

export const DesignSystemProvider = ({ children }: PropsWithChildren) => (
  <MegaMenuProvider>
    <SidepanelProvider>{children}</SidepanelProvider>
  </MegaMenuProvider>
);
